export default __webpack_public_path__ + "static/media/Color_Blue.d00e5c22.svg";